'use client'
import {
  useAccordionItemContext
} from "./chunk-RUEU7BLR.mjs";

// src/use-accordion-item-state.ts
function useAccordionItemState() {
  const { isOpen, isDisabled, onClose, onOpen } = useAccordionItemContext();
  return { isOpen, onClose, isDisabled, onOpen };
}

export {
  useAccordionItemState
};
//# sourceMappingURL=chunk-3OO6EZWZ.mjs.map